import palette from 'src/designSystem/variables/palette'
import {
  TrustPortalFaq,
  TrustPortalUpdates,
} from '@trustero/trustero-api-web/lib/trust/trust_pb'

export interface TrustPortalBannerStyle {
  fontColor?: string
  fontStyle?: 'normal' | 'bold' | 'italic' | 'underline'
  fontFamily?: string
  fontSize?: string
  bannerBackgroundOption?: BrandingBackgrounds | 'custom'
  bannerCustomBackground?: string[]
}

export enum BrandingBackgrounds {
  GREENISH = 'Greenish',
  REDDISH = 'Reddish',
  BLUISH = 'Bluish',
  YELLOWISH = 'Yellowish',
  WHITE = 'White',
  BLACK = 'Black',
}

export const BrandingBackgroundColors: Record<BrandingBackgrounds, string[]> = {
  [BrandingBackgrounds.GREENISH]: ['#C2E7DC', '#D5F2E9', '#CBE2BA'],
  [BrandingBackgrounds.REDDISH]: ['#F0D1DD', '#F0D5CF', '#FFB8B9'],
  [BrandingBackgrounds.BLUISH]: ['#95CAE9', '#CFE5F0', '#DCD8E7'],
  [BrandingBackgrounds.YELLOWISH]: ['#E7E3C2', '#F2E2D5', '#FDE4CA'],
  [BrandingBackgrounds.WHITE]: ['#FFFFFF'],
  [BrandingBackgrounds.BLACK]: [palette.neutral[900]],
}

export const BrandingBackgroundStyleText = (
  background: BrandingBackgrounds,
): string => {
  return `linear-gradient(90deg, ${BrandingBackgroundColors[background].join(
    ', ',
  )})`
}

export const CONTROL_CHECK_COLUMNS = [
  {
    name: 'ID',
    isCentered: false,
  },
  {
    name: 'Control Name',
    isCentered: false,
  },
  {
    name: 'Objective',
    isCentered: false,
  },
]

export enum ModalActionType {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete',
}

export interface TrustPortalFaqModalState {
  actionType: ModalActionType
  data: TrustPortalFaq | null
  index: number | null
}

export interface TrustPortalUpdateModalState {
  actionType: ModalActionType
  data: TrustPortalUpdates | null
}
